<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="time-off-v3.update.basicInformation.header" [back]="true"></app-header>
    <!-- Use this component with a form on the outside for validation -->
    <form #form="ngForm">
        <app-basic-information-update-card
            [timeOffPolicy]="timeOffPolicy"
            [timeOffTypes]="timeOffTypes"
            [timeOffApprovalFlows]="timeOffApprovalFlows"
            (onCreateTimeOffType)="redirectToTimeOffCreation($event)"
        ></app-basic-information-update-card>
    </form>

    <div class="buttons flex flex-end">
        <ui-button type="ghost" (click)="onCancel()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSave()">{{ 'save' | translate }}</ui-button>
    </div>
</div>
